import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ResponsiveContainer,
  ResponsiveContent,
  ResponsiveHeader,
  ResponsiveFooter,
} from "../ui/ResponsiveLayout";

const Frame157: React.FC = () => {
  const navigate = useNavigate();

  const handleStart = () => {
    navigate("/frame-172");
  };

  const handleBack = () => {
    navigate("/frame-140");
  };

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <ResponsiveHeader title="Thinking About Your Legacy" />

        <div className="max-w-4xl space-y-8">
          {/* Intro */}
          <div className="space-y-4">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              This is a space to reflect on how you’d like to be remembered by
              the people who matter most to you. Here, you can capture memories,
              messages, and moments that can be shared with your loved ones
              after you’re gone.
            </p>
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              There’s no right or wrong way to begin — you can start with a
              single thought and return whenever you’re ready.
            </p>
          </div>

          {/* What You'll Do */}
          <div className="bg-white rounded-lg border border-neutral-200 p-6">
            <h2 className="text-xl font-semibold text-cyan-900 mb-4">
              What You’ll Do
            </h2>

            <div className="space-y-4">
              {/* 1 */}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  1
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Choose who you’d like to leave memories for
                  </p>
                </div>
              </div>

              {/* 2 */}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  2
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Create and organize personal messages, photos, or videos
                  </p>
                </div>
              </div>

              {/* 3 */}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  3
                </div>
                <div>
                  <p className="text-stone-700 font-bold">
                    Review and update your legacy over time
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-cyan-50 border border-cyan-100 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-cyan-900 mb-3">
              Why This Matters
            </h2>

            <ul className="space-y-2 text-stone-700">
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Gives your loved ones something meaningful to hold onto
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Helps ensure your memories and intentions are preserved in
                  your own words
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Creates a lasting emotional legacy beyond legal and financial
                  planning
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>
                  Offers a chance to pause and reflect on what matters most
                </span>
              </li>
            </ul>
          </div>

          {/* Estimated Time */}
          <div className="text-center text-stone-600">
            <p className="text-sm">
              <span className="font-semibold">Estimated time:</span> Most people
              spend about 20 minutes here.
            </p>
            <p className="text-xs mt-1">
              You can save your progress and come back at any time.
            </p>
          </div>
        </div>
      </ResponsiveContent>

      <ResponsiveFooter
        title="Leave Behind Memories and Messages"
        subtitle="Reflect on how you want to be remembered"
        progressPercent={0}
        onNext={handleStart}
        onBack={handleBack}
        nextText="Get Started"
        backText="Back to Dashboard"
      />
    </ResponsiveContainer>
  );
};

export default Frame157;